import { render, staticRenderFns } from "./submissions.vue?vue&type=template&id=7780a350&"
import script from "./submissions.vue?vue&type=script&lang=js&"
export * from "./submissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports